import { create } from "zustand";
import { devtools } from "zustand/middleware";
export const useDrawer = create()(devtools((set)=>({
        isDrawerOpen: false,
        setIsDrawerOpen: (shouldOpen)=>set({
                isDrawerOpen: shouldOpen
            })
    })));
